import React from "react";
import { Outlet } from "react-router-dom";

const Rotas = () => {
  return <Outlet />;
};

export default React.memo(Rotas);
